import { withSvgIconSimple } from './withSvgIconSimple';

export const ArrowRight = withSvgIconSimple(
  <path d="M1 1L5 5L1 9" stroke="currentColor" strokeWidth="currentWidth" />,
  { viewBox: '0 0 7 10' },
);
